<template>
  <div class="custom-banner">
    <div class="custom-banner__content">
      <p class="custom-banner__title">
        &iquest;Tu negocio necesita m&aacute;s volumen o un equipo m&aacute;s
        grande?
      </p>
      <p class="custom-banner__text">
        Dise&ntilde;amos un plan que se adapte a tu operaci&oacute;n: volumen de
        documentos personalizado, usuarios ilimitados, env&iacute;o masivo,
        soporte dedicado y facturaci&oacute;n a medida.
      </p>
    </div>
    <button class="custom-banner__btn" @click="$emit('contact')">
      Conversemos sobre tu plan
    </button>
  </div>
</template>

<script>
export default {
  name: "CustomPlanBanner"
};
</script>

<style lang="scss" scoped>
.custom-banner {
  background: #2d2b55;
  border-radius: 14px;
  padding: 36px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  flex-wrap: wrap;

  &__content {
    flex: 1;
    min-width: 260px;
  }

  &__title {
    font-size: 20px;
    font-weight: 700;
    color: #fff !important;
    margin: 0 0 8px;
    line-height: 1.3;
  }

  &__text {
    font-size: 14px;
    color: #fff !important;
    margin: 0;
    line-height: 1.6;
  }

  &__btn {
    padding: 14px 32px;
    border-radius: 9px;
    border: none;
    background: #3ecfb4;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
    transition: all 0.15s;
    font-family: "Plus Jakarta Sans", sans-serif;

    &:hover {
      background: #1d9e75;
    }
  }
}

@media (max-width: 640px) {
  .custom-banner {
    padding: 24px 20px;
    flex-direction: column;
    text-align: center;

    &__btn {
      width: 100%;
    }
  }
}
</style>
